
$( document ).ready(function() {
$('#ProductSelect-liveroz1a-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('#ProductSelect-liveroz1a-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('#ProductSelect-liveroz1a-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');
//$('#AddToCartText-liveroz1a').text('CLAIM OFFER');
//$('#AddToCartText-liveroz2a').text('CLAIM OFFER');
$('#AddToCartForm-liveroz1a input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-liveroz1a input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 30% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $90.00</span><span id="sub_price" class="sub_price igPrice">$63</span></div>');
$('#AddToCartForm-liveroz2a input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-liveroz2a input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 30% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $99.00</span><span id="sub_price" class="sub_price igPrice">$69.30</span></div>');

});

$(document).ready(function(){
setTimeout(function(){
//       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
$('#AddToCartForm-liveroz1a .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1a .sub_price').text('$63');
$('#AddToCartForm-liveroz1a .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-liveroz2a .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz2a .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-liveroz1a .sub_percent').attr("id","subpercent");
$('#AddToCartForm-liveroz2a .sub_percent').attr("id","subpercent");

$('#AddToCartForm-liveroz1a .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-liveroz1a .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-liveroz2a .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-liveroz2a .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-liveroz1a .rtx-subscription-label .rtxshotsubpricee').text('($2.63 per Dose shot)');
$('#AddToCartForm-liveroz1a .onetime .rtx-shot-one-pricee').text('($3.75 per Dose shot)');
$('#AddToCartForm-liveroz2a .rtx-subscription-label .rtxshotsubpricee').text('($2.88 per Dose shot)');
$('#AddToCartForm-liveroz2a .onetime .rtx-shot-one-pricee').text('($4.13 per Dose shot)');
$('#igPrice').remove();
}, 1000);


});
$(document).ready(function(){
setTimeout(function(){
$('.rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 1000);

});

$("#ProductSelect-liveroz1a-option-0>div:first-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-liveroz1a').click();  
//$('#purchaseTypeSubscription-14653054910827---AddToCartForm-liveroz1a').click();
setTimeout(function(){     
$('#AddToCartForm-liveroz1a .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1a .sub_price').text('$63');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1a .rtx_strike').text('$90.00');
$('#AddToCartForm-liveroz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
 // $('.rtx-subscription>div>label:first-child').click();
$('#AddToCartForm-liveroz1a .rtx-subscription-label .rtxshotsubpricee').text('($2.63 per Dose shot)');
$('#AddToCartForm-liveroz1a .onetime .rtx-shot-one-pricee').text('($3.75 per Dose shot)');
}, 100);
});    

$("#ProductSelect-liveroz1a-option-0>div:last-child").click(function() {
  
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-liveroz1a').click();
//$('#purchaseTypeSubscription-14653054910827---AddToCartForm-liveroz1a').click();
setTimeout(function(){     
$('#AddToCartForm-liveroz1a .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1a .sub_price').text('$112.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1a .rtx_strike').text('$160.00');
$('#AddToCartForm-liveroz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
 $('#AddToCartForm-liveroz1a .rtx-subscription-label .rtxshotsubpricee').text('($2.33 per Dose shot)');
$('#AddToCartForm-liveroz1a .onetime .rtx-shot-one-pricee').text('($3.33 per Dose shot)');
 // $('.rtx-subscription>div>label:first-child').click();
}, 100);
});
$(".rtx-subscription>div>label:last-child").click(function() {

$('#igPrice').remove();
});


jQuery('.pr-img img').click(function() {
var thissrc = jQuery(this).attr('data-src');
jQuery('.main-pr').attr('src', thissrc);
jQuery('.pr-img img').removeClass('activepr');
jQuery(this).addClass('activepr');
});


jQuery('.oztab>span:first-child').click(function() {
$(this).addClass('active');
$('.oztab>span:last-child').removeClass('active');
$('#AddToCartForm-liveroz1a').show();
$('#AddToCartForm-liveroz2a').hide();


});

jQuery('.oztab>span:last-child').click(function() {
$(this).addClass('active');
$('.oztab>span:first-child').removeClass('active');
$('#AddToCartForm-liveroz1a').hide();
$('#AddToCartForm-liveroz2a').show();

  $('#cozcs').hide();
});


jQuery('.oztaba>span:first-child').click(function() {
$(this).addClass('active');
$('.oztaba>span:last-child').removeClass('active');
$('#AddToCartForm-liveroz1aa').show();
$('#AddToCartForm-liveroz2aa').hide();


});

jQuery('.oztaba>span:last-child').click(function() {
$(this).addClass('active');
$('.oztaba>span:first-child').removeClass('active');
$('#AddToCartForm-liveroz1aa').hide();
$('#AddToCartForm-liveroz2aa').show();

  $('#cozcs').hide();
});






jQuery('.pr-img img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr').attr('src', thissrc);
jQuery('.pr-img img').removeClass('activepr');
jQuery(this).addClass('activepr');

});

jQuery('.pr-img2 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr2').attr('src', thissrc);
jQuery('.pr-img2 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr1').attr('src', thissrc);
jQuery('.pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img4 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr4').attr('src', thissrc);
jQuery('.pr-img4 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});
$(document).ready(function(){
setTimeout(function(){
$('.nfs-nocomitment').html('<ul><li>Save 15% off recurring orders</li><li>Give your liver the support it needs with 2-4oz per day!</li><li>No commitments! Adjust or cancel anytime</li><li>30-day money-back guarantee</li></ul>');
}, 2000);
});


          
            setTimeout(function(){
            $('#AddToCartForm-liveroz2a .sub_percent').text('(30%)');
            $('#AddToCartForm-liveroz2a .sub_percent').attr("id","subpercent");
            $('#AddToCartForm-liveroz2a #sub_price').text('$69.30');
               $('#AddToCartForm-liveroz2a .sub_price').removeAttr("data-rtx-subscription-price");
            $("#AddToCartForm-liveroz2a .rtx-subscription-dropdown").change(function(){
            $('#AddToCartForm-liveroz2a .sub_price').text('$69.30');
            });
            $("#AddToCartForm-liveroz2a .rtx-subscription label").click(function(){
            $('#AddToCartForm-liveroz2a .sub_price').text('$69.30');
            
            });
            }, 100);

          
           
            jQuery('.lpsoplusclick').click(function() {
$(this).toggleClass('active');
if ($(this).text() == "+")
  {     
  $(this).text("-")
            }  
else
 {
    $(this).text("+");
}
$(this).prev('.lpso-ig_box_popup').toggle();

});


$( document ).ready(function() {
$('#ProductSelect-liveroz1aa-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('#ProductSelect-liveroz1aa-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('#ProductSelect-liveroz1aa-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');
//$('#AddToCartText-liveroz1a').text('CLAIM OFFER');
//$('#AddToCartText-liveroz2a').text('CLAIM OFFER');
$('#AddToCartForm-liveroz1aa input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-liveroz1aa input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 30% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $90.00</span><span id="sub_price" class="sub_price igPrice">$63</span></div>');
$('#AddToCartForm-liveroz2aa input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-liveroz2aa input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 30% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $99.00</span><span id="sub_price" class="sub_price igPrice">$69.30</span></div>');

});

$(document).ready(function(){
setTimeout(function(){
//       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
$('#AddToCartForm-liveroz1aa .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1aa .sub_price').text('$63');
$('#AddToCartForm-liveroz1aa .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1aa .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-liveroz2aa .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz2aa .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-liveroz1aa .sub_percent').attr("id","subpercent");
$('#AddToCartForm-liveroz2aa .sub_percent').attr("id","subpercent");

$('#AddToCartForm-liveroz1aa .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-liveroz1aa .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-liveroz2aa .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-liveroz2aa .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-liveroz1aa .rtx-subscription-label .rtxshotsubpricee').text('($2.63 per Dose shot)');
$('#AddToCartForm-liveroz1aa .onetime .rtx-shot-one-pricee').text('($3.75 per Dose shot)');
$('#AddToCartForm-liveroz2aa .rtx-subscription-label .rtxshotsubpricee').text('($2.88 per Dose shot)');
$('#AddToCartForm-liveroz2aa .onetime .rtx-shot-one-pricee').text('($4.13 per Dose shot)');
$('#igPrice').remove();
$('.rtx-subscription-single-label').hide();
}, 1000);


});


$("#ProductSelect-liveroz1aa-option-0>div:first-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-liveroz1aa').click();
setTimeout(function(){     
$('#AddToCartForm-liveroz1aa .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1aa .sub_price').text('$63');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1aa .rtx_strike').text('$90.00');
$('#AddToCartForm-liveroz1aa .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.rtx-subscription>div>label:first-child').click();
$('#AddToCartForm-liveroz1aa .rtx-subscription-label .rtxshotsubpricee').text('($2.63 per Dose shot)');
$('#AddToCartForm-liveroz1aa .onetime .rtx-shot-one-pricee').text('($3.75 per Dose shot)');
}, 100);
});    

$("#ProductSelect-liveroz1aa-option-0>div:last-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-liveroz1aa').click();
setTimeout(function(){     
$('#AddToCartForm-liveroz1aa .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz1aa .sub_price').text('$112.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-liveroz1aa .rtx_strike').text('$160.00');
$('#AddToCartForm-liveroz1aa .rtx_strike').removeAttr("data-rtx-onetime-price");
 $('#AddToCartForm-liveroz1aa .rtx-subscription-label .rtxshotsubpricee').text('($2.33 per Dose shot)');
$('#AddToCartForm-liveroz1aa .onetime .rtx-shot-one-pricee').text('($3.33 per Dose shot)');
  $('.rtx-subscription>div>label:first-child').click();
}, 100);
});


jQuery('.oztab>span:first-child').click(function() {
$(this).addClass('active');
$('.oztab>span:last-child').removeClass('active');
$('#AddToCartForm-liveroz1aa').show();
$('#AddToCartForm-liveroz2aa').hide();


});

jQuery('.oztab>span:last-child').click(function() {
$(this).addClass('active');
$('.oztab>span:first-child').removeClass('active');
$('#AddToCartForm-liveroz1aa').hide();
$('#AddToCartForm-liveroz2aa').show();

  $('#cozcs').hide();
});



jQuery('.oztab1>span:first-child').click(function() {
$(this).addClass('active');
$('.oztab1>span:last-child').removeClass('active');
$('#AddToCartForm-cholesteroloz3').show();
$('#AddToCartForm-cholesteroloz4').hide();

});

jQuery('.oztab1>span:last-child').click(function() {
$(this).addClass('active');
$('.oztab1>span:first-child').removeClass('active');
$('#AddToCartForm-cholesteroloz3').hide();
$('#AddToCartForm-cholesteroloz4').show();

setTimeout(function(){  
$('#AddToCartForm-liveroz2aa .rtx-subscription-label .rtxshotsubprice').text('($2.88 per Dose shot)');
$('#AddToCartForm-liveroz2aa .onetime .rtx-shot-one-price').text('($4.13 per Dose shot)');
}, 100);
});




          
setTimeout(function(){
$('#AddToCartForm-liveroz2aa .sub_percent').text('(30%)');
$('#AddToCartForm-liveroz2aa .sub_percent').attr("id","subpercent");
$('#AddToCartForm-liveroz2aa #sub_price').text('$69.30');
   $('#AddToCartForm-liveroz2aa .sub_price').removeAttr("data-rtx-subscription-price");
$("#AddToCartForm-liveroz2aa .rtx-subscription-dropdown").change(function(){
$('#AddToCartForm-liveroz2aa .sub_price').text('$69.30');
});
$("#AddToCartForm-liveroz2aa .rtx-subscription label").click(function(){
$('#AddToCartForm-liveroz2aa .sub_price').text('$69.30');

});
$('#AddToCartForm-liveroz1a .rtx-selection-label').hide();
$('#AddToCartForm-liveroz1a .rtx-subscription-single-label').hide();
$('#AddToCartForm-liveroz1aa .rtx-selection-label').hide();
$('#AddToCartForm-liveroz1a .rtx-subscription-single-label').hide();
}, 100);

          
           
         